import Vue from 'vue';
var scrollDirective = function () {
    Vue.directive('scroll', {
        inserted: function (el, binding) {
            var customFunction = function (evt) {
                if (binding.value(evt, el)) {
                    window.removeEventListener('scroll', customFunction);
                }
            };
            window.addEventListener('scroll', customFunction, {
                passive: true,
            });
        },
    });
};
export default scrollDirective;



//////////////////
// WEBPACK FOOTER
// ./src/components/directives/ScrollDirective.ts
// module id = o+zg
// module chunks = 18